import { mapMutations, mapActions, mapGetters } from "vuex";
import TheSidebarMenuItem from "@/components/TheSidebarMenuItem";
import { EVENTS } from "@/utils";
import AccountsMixin from "@/mixins/AccountsMixin.vue";
export default {
  name: "TheSidebarMenu",
  emits: ["menu-click", "handleCollapse", "selectMenuItem"],
  mixins: [AccountsMixin],
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    },
    isHovering: {
      type: Boolean,
      default: false
    },
    useSettings: {
      type: Boolean,
      default: false
    },
    openItemText: String
  },
  components: {
    TheSidebarMenuItem
  },
  computed: {
    ...mapGetters(["isInventoryDisabledGet"]),
    menuItems() {
      return this.useSettings ? this.settingsItems : this.nonSettingsItems;
    },
    onlyVisibleToOmnyUsersRule() {
      const user = window.auth_user;
      return user?.isOmnyAdmin || user?.isOmnyUser || false;
    },
    productsChildrenView() {
      const commonItems = [{
        text: "Content",
        url: "/seo",
        featureName: "default"
      }, {
        text: "Pricing and Margin",
        url: "/pricing-and-margin",
        featureName: "default"
      }, {
        text: "COGS",
        url: "/cogs-data",
        featureName: "cogsdatafeature"
      }];
      return commonItems;
    },
    marketInsightsChildren() {
      let children = [{
        text: "Market Share",
        url: "/market-share",
        featureName: "marketsharefeature"
      }];
      return this.isInventoryDisabledGet() ? children : [...children, {
        text: "Search Funnel",
        url: "/search-funnel",
        featureName: "searchfunnelfeature"
      }];
    },
    nonSettingsItems() {
      return [{
        text: "Dashboard",
        url: "/",
        icon: "home-new-ui",
        color: "#FFFFFF",
        featureName: "default"
      }, {
        text: "Products",
        icon: "products-new-ui",
        color: "#FFFFFF",
        featureName: "default",
        children: this.productsChildrenView
      }, {
        text: "Inventory",
        icon: "checklist",
        color: "#FFFFFF",
        featureName: "inventoryfeature",
        children: [{
          text: "Demand Forecasting",
          url: "/demand-forecasting",
          featureName: "demandforecastingfeature"
        }, {
          text: "Product Data",
          url: "/product-data",
          featureName: "productdatafeature"
        }, {
          text: "Inventory Coverage",
          url: "/inventory-coverage",
          featureName: "default"
        }]
      }, {
        text: "Advertising",
        icon: "advertisement-new-ui",
        color: "#FFFFFF",
        featureName: "advertisingv2feature",
        children: [{
          text: "Sponsored Ads",
          url: "/advertising",
          featureName: "default"
        }, {
          text: "DSP",
          url: "/dsp",
          featureName: "dspmodulefeature",
          disabled: !this.isAnyDSPAccountPresent(),
          disabledText: "Connect a DSP account to unlock"
        }]
      }, {
        text: "Customer Insights",
        icon: "customer-insights-icon",
        url: "/customer-insights",
        color: "#FFFFFF",
        featureName: "customerinsightsfeature"
      }, {
        text: "Profit and Loss",
        icon: "coins-stacked",
        url: "/profit-and-loss",
        color: "#FFFFFF",
        featureName: "profitandlossfeature"
      }, {
        text: "Market Insights",
        icon: "market-insights-icon",
        color: "#FFFFFF",
        featureName: "marketinsightsfeature",
        children: this.marketInsightsChildren
      }];
    }
  },
  data() {
    return {
      //openItemText: null,
      //nonSettingsItems:
      settingsItems: [{
        text: "Notifications",
        url: "/alerts-page",
        icon: "notification-new-ui",
        color: "#FFFFFF",
        featureName: "alertsfeature"
      },
      // {
      //   text: "Connections",
      //   icon: "account-gear",
      //   color: "#FFFFFF",
      //   featureName: "default",
      //   children: [
      //     { text: "Amazon Seller Central", url: "/amz-seller-central" },
      //     { text: "Amazon Advertising", url: "/amz-advertising" },
      //     { text: "Amazon Vendor Central", url: "/amz-vendor-central" },
      //   ],
      // },
      {
        text: "Help",
        action: "openIntercom",
        icon: "help-new-ui",
        color: "#FFFFFF",
        featureName: "helpmenufeature",
        event: "intercomModuleOpened"
      }, {
        text: "Settings",
        icon: "settings-new-ui",
        color: "#FFFFFF",
        featureName: "default",
        children: [{
          text: "Connections",
          url: "/connections",
          featureName: "default"
        },
        //{ text: "Manage Account Members"}, //url: "/manageaccountmembers", no design yet so disabled it
        {
          text: "Account Management",
          url: "/account",
          featureName: "default"
        }, {
          text: "User Profile",
          url: "/profile",
          featureName: "default"
        }, {
          text: "Sign-Out",
          action: "logout",
          featureName: "default"
        }]
      }]
    };
  },
  methods: {
    ...mapMutations(["authTokenSet"]),
    ...mapActions(["authLogout"]),
    async onClick(item) {
      if (item.children && item.children.length > 0) {
        this.$emit("menu-click", item);
      }
      if (item.text === "Dashboard") {
        //logic has been moved from child to the parent
        this.$emit("menu-click", item);
      }
      if (item.text == "Content") {
        window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
          event_name: "contentModuleOpened",
          properties: {}
        });
      }
    }
  }
};